import { AdjustAction } from "./adjustInventoryActions";

export { ACTION_LABELS, AdjustAction } from "./adjustInventoryActions";

export interface AdjustmentRow {
    id: string;
    action: AdjustAction;
    reason: string;
    qty: number;
}

export interface InventoryStats {
    available: number;
    unavailable: number;
    onHand: number;
}

const REMOVAL_REASONS = [
    "Disposed/Destroyed",
    "Scrapped (Non-Recoverable)",
    "Donated/Transferred Out",
    "Stolen/Irrecoverable Loss",
    "Obsolete/Expired",
    "Write-Off",
    "Correction",
];

export type RowStatus = "idle" | "loading" | "success" | "error";

export const REASONS: Record<AdjustAction, string[]> = {
    [AdjustAction.ADD_INVENTORY]: ["Received", "Restock", "Correction"],
    [AdjustAction.MOVE_TO_UNAVAILABLE]: [
        "Safety Stock",
        "Damaged",
        "Quality Control",
        "Theft/Loss",
        "Promotion/Donation",
        "Permanently Removed",
        "Other",
        "Correction",
    ],
    [AdjustAction.MOVE_TO_AVAILABLE]: [
        "Quality Control Passed",
        "Damage Repaired/Rework Completed",
        "Error Reversal",
        "Stock Recovered",
        "Promotion/Donation Reversal",
        "Hold Released",
        "Correction",
    ],
    [AdjustAction.REMOVE_FROM_AVAILABLE]: REMOVAL_REASONS,
    [AdjustAction.REMOVE_FROM_UNAVAILABLE]: REMOVAL_REASONS,
};

export const getMaxQty = (action: AdjustAction, state: InventoryStats): number => {
    switch (action) {
        case AdjustAction.MOVE_TO_UNAVAILABLE:
            return state.onHand;
        case AdjustAction.REMOVE_FROM_AVAILABLE:
            return state.available;
        case AdjustAction.MOVE_TO_AVAILABLE:
        case AdjustAction.REMOVE_FROM_UNAVAILABLE:
            return state.unavailable;
        case AdjustAction.ADD_INVENTORY:
            return Number.POSITIVE_INFINITY;
    }
};
